var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66892 1.88672C10.1104 1.45462 10.1104 0.756182 9.66892 0.324078C9.22749 -0.108026 8.51397 -0.108026 8.07254 0.324078L4.99944 3.33223L1.92746 0.324078C1.48603 -0.108026 0.77138 -0.108026 0.331076 0.324078C-0.110358 0.756182 -0.110358 1.45462 0.331076 1.88672L4.20124 5.6762C4.42252 5.8917 4.71041 6 4.99944 6C5.28846 6 5.57748 5.8917 5.79763 5.6762L9.66892 1.88672Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottom);
export default __webpack_public_path__ + "static/media/arrow-bottom.c4bc1666.svg";
export { ForwardRef as ReactComponent };